import { Page } from '@/core/architecture'

import { DmRoomDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * DmRoomDetail Page
 * Implemented as a practical sample.
 */
export const DmRoomDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <DmRoomDetailTemplate state={state} {...actions} />
}
